import React from 'react';
import PropTypes from 'prop-types';
import { useHistory, useRouteMatch } from 'react-router-dom';
import makeStyles from '@mui/styles/makeStyles';
import { Tooltip, Button } from '@mui/material';
import cn from 'classnames';
import { useDeviceDetect } from 'hooks';

import Styles from './styles';

const useStyles = makeStyles(Styles);

function NavigationButton({ icon, link, label, isSecureMessages, count, classes, isSettingsNavigation, onClick }) {
  const styles = useStyles();
  const history = useHistory();
  const { isDesktop } = useDeviceDetect();

  const isPathMatch = useRouteMatch({
    path: link,
    exact: !!isSettingsNavigation,
  });

  const tabClasses = cn(styles.tab, classes, { [styles.activeTab]: isPathMatch });
  const pushLink = () => {
    onClick();
    return history.location.pathname !== link && history.push(link);
  };

  return isSettingsNavigation ? (
    <Button
      data-testid="navigation-button"
      className={classes}
      variant={isPathMatch && isDesktop ? 'contained' : 'text'}
      onClick={pushLink}
      color={isPathMatch && isDesktop ? 'primary' : 'font'}
    >
      {label}
    </Button>
  ) : (
    <Tooltip title={label} placement={!isDesktop ? 'top' : 'bottom'} key={label}>
      <button data-testid="navigation-button" className={tabClasses} type="button" onClick={pushLink}>
        <div className={styles.iconWrapper}>{icon}</div>
        {isSecureMessages && count > 0 && <span className={styles.count}>{count}</span>}
      </button>
    </Tooltip>
  );
}

NavigationButton.propTypes = {
  icon: PropTypes.element,
  link: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  isSecureMessages: PropTypes.bool,
  count: PropTypes.number,
  classes: PropTypes.string,
  isSettingsNavigation: PropTypes.bool,
  onClick: PropTypes.func,
};

NavigationButton.defaultProps = {
  isSecureMessages: false,
  icon: null,
  count: null,
  classes: '',
  isSettingsNavigation: false,
  onClick: () => {},
};

export default NavigationButton;
